// 框架
import Vue from 'vue'
import App from './App'
import VConsole from 'vconsole';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'umy-ui/lib/theme-chalk/index.css';
import { i18n } from './lang/index'
import './vant.js'

// 通用工具
import {router} from './router'
import store from './store'
import request from './request'
import cookie from 'js-cookie'
import MD5 from 'spark-md5'
import Script from './utils/Script.js'
import Scan from './utils/Scan.js'
import Upload from './utils/Upload.js'
import { start as Socket } from './utils/Socket.js'
import Utils from './utils/Utils.js'
import Sortable from 'sortablejs';
import './ca/index.js'
import './utils/moment.config'

// 公共组件
import Scanner from '@/components/common/Scanner/Scanner.js'
import ScanButton from '@/components/common/ScanButton.vue'
import InstrumentDetail from '@/components/instrument/InstrumentDetail.vue'
import QuestionRecord from '@/components/instrument/QuestionRecord.vue'
import PictureSelect from '@/components/common/PictureSelect/index.vue'
import TableHeaderEditor from '@/components/common/TableHeaderEditor.vue'
import { UTable, UTableColumn, UxGrid, UxTableColumn } from 'umy-ui'
import CenterSelect from '@/components/common/CenterSelect.vue'

// 引入echarts
import * as echarts from 'echarts/core'
import { LabelLayout, UniversalTransition } from 'echarts/features'
import { CanvasRenderer } from 'echarts/renderers'
import {
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LegendComponent,
  GraphicComponent,
} from 'echarts/components'

// 全局样式
import './assets/css/reset.scss'
import './assets/css/common.scss'

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  LegendComponent,
  GraphicComponent
]);

Vue.use(UTable)
Vue.use(UTableColumn)
Vue.use(UxGrid)
Vue.use(UxTableColumn)

Vue.component(ScanButton.name, ScanButton)
Vue.component(InstrumentDetail.name, InstrumentDetail)
Vue.component(QuestionRecord.name, QuestionRecord)
Vue.component(PictureSelect.name, PictureSelect)
Vue.component(TableHeaderEditor.name, TableHeaderEditor)
Vue.component(CenterSelect.name, CenterSelect)

Vue.use(ElementUI)

Vue.prototype.$cookie = cookie // cookie操作插件
Vue.prototype.$request = request // 接口请求组件
Vue.prototype.$scan = Scan.scan // 扫码枪监听组件
Vue.prototype.$upload = Upload // 通用上传组件
Vue.prototype.$md5 = MD5 // md5生成插件
Vue.prototype.$script = Script // 外部资源引用组件
Vue.prototype.$socket = Socket // 全局socket监听组件
Vue.prototype.$utils = Utils // 工具方法
Vue.prototype.$sort = Sortable // 表格可排序方法
Vue.prototype.$scanner = Scanner // 摄像头扫码组件
Vue.prototype.$echarts = echarts // echarts
Vue.prototype.$bus = new Vue() // 设置挂载至vue原型上
Vue.config.productionTip = false

// 内网开发环境开启vconsole
process.env.NODE_ENV === 'preview' && new VConsole()
// 本地开发环境启用mock
process.env.NODE_ENV === 'development' && require('./mock')

const ProOpts = {
  el: '#app',
  store,
  router,
  i18n: process.env.NODE_ENV.includes('dev') ? i18n : undefined,
  render: h => h(App)
}

export default new Vue(ProOpts)

window._hj_scan = function(code) {
  const c = `${code}`
  const dom = window.document
  if (window._ScanInstance && window._ScanInstance.isAttachedTo(dom)) {
    window._ScanInstance.simulate(window.document, c)
  } else {
    console.log('未找到扫描方法')
  }
}
